import React from 'react';
import Blue from '../Component/Blue/Blue';
import Fancy from '../Component/Fancy/Fancy';
import Functional from '../Component/Functional/Functional';
import Green from '../Component/Green/Green';
import Natural from '../Component/Natural/Natural';
import { NavBar } from '../Component/NavBar/NavBar';
import Primary from '../Component/Primary/Primary';
import Red from '../Component/Red/Red';
import Yellow from '../Component/Yellow/Yellow';
import Paragraph from '../Component/Paragraph/Paragraph';
import Tab from '../Component/Tab/Tab';
import Footer from '../Component/Footer/Footer';
const initialState = {
  selectedColor: 'All',
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'SET_COLOR':
      return { ...state, selectedColor: action.payload };
    default:
      return state;
  }
};

export default function HomePage() {
  const [state, dispatch] = React.useReducer(reducer, initialState);

  const renderColor = (color) => {
    dispatch({ type: 'SET_COLOR', payload: color });
  };

  const renderComponentByColor = () => {
    switch (state.selectedColor) {
      case 'red':
        return <Red />;
      case 'green':
        return <Green />;
      case 'Yellow':
        return <Yellow />;
      case 'Fancy':
        return <Fancy />;
      case 'Blue':
        return <Blue />;
      case 'Primary':
        return <Primary />;
      case 'Functional':
        return <Functional />;
      case 'Neutral':
        return <Natural />;
      default:
        // Render all components when no specific color is selected
        return (
          <>
            <Red />
            <Green />
            <Yellow />
            <Fancy />
            <Blue />
            <Primary />
            <Functional />
            <Natural />
          </>
        );
    }
  };

  return (
    <div className="relative">
      <NavBar />
      <Tab renderColor={renderColor} />
      <div>
        <Paragraph
          className=" text-[32px] text-[#019031] pt-4 ml-6 text-center "
          paragraphText="Click on button for copy :)"
        />
        <div className="fixed rotate-90 mt-[320px] left-[-151px] ">
          <Footer />
        </div>
        {renderComponentByColor()}
      </div>
    </div>
  );
}
